import { OrbType } from "../..";
export class ComboBombStripped {
    constructor(board, p1, p2, prng) {
        this.eliminatedOrbs = [];
        this.mutatedOrbs = [];
        const orb1 = board[p1.c][p1.r];
        const orb2 = board[p2.c][p2.r];
        let color;
        let pBomb;
        if (orb1.type === OrbType.BOMB) {
            color = orb2.color;
            pBomb = p1;
            this.eliminatedOrbs.push({
                p: p1,
                type: OrbType.BOMB,
                n: 40,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        else {
            color = orb1.color;
            pBomb = p2;
            this.eliminatedOrbs.push({
                p: p2,
                type: OrbType.BOMB,
                n: 40,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        const cols = board.length;
        const rows = board[0].length;
        for (let c = 0; c < cols; c++) {
            for (let r = 0; r < rows; r++) {
                const orb = board[c][r];
                // ponemos otros orbs rayados que pueda haber ya en el tablero
                if (orb.color === color && (orb.type === OrbType.NORMAL || orb.type === OrbType.STRIPPED_VER || orb.type === OrbType.STRIPPED_HOR)) {
                    let type;
                    const n = 5 + Math.floor(20 * prng.getRandom());
                    if (orb.type === OrbType.NORMAL) {
                        type = prng.getRandom() > .5 ? OrbType.STRIPPED_VER : OrbType.STRIPPED_HOR;
                        orb.type = type;
                        this.mutatedOrbs.push({ p: { c: c, r: r },
                            type: type,
                            n: n,
                            pBomb: pBomb
                        });
                    }
                    else {
                        type = orb.type;
                    }
                    this.eliminatedOrbs.push({
                        p: { c: c, r: r },
                        type: type,
                        n: n + 15,
                        triggeringOrbColor: null,
                        collapsing: false,
                        collapsingPosition: null,
                        isComboWrappedWrappedOrb: false,
                        pBomb: pBomb
                    });
                }
            }
        }
    }
    getEliminatedOrbs() {
        return this.eliminatedOrbs;
    }
    getMutatedOrbs() {
        return this.mutatedOrbs;
    }
}
//# sourceMappingURL=data:application/json;base64,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